import { useContext } from 'react';
import { QuoteTypeStoreContext } from '../utils/quoteTypeStoreContext';
import { IQuoteTypeStore } from '../stores/common/iQuoteTypeStore';

interface QuoteTypeStoreHook {
  quoteTypeStore: IQuoteTypeStore;
}

export const useQuoteTypeStore = (): QuoteTypeStoreHook => {
  const quoteTypeStore = useContext(QuoteTypeStoreContext);
  return { quoteTypeStore };
};
